/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */
import * as References from './ApprovalsConfigurationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovalConfiguration
 */
export const GET_APPROVAL_CONFIGURATION_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovalConfiguration';
export const GET_APPROVAL_CONFIGURATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVAL_CONFIGURATION_QUERY_FIELD_NAME,
  args: ['approvalType', 'approvalTypeId', 'approvalAction'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getApprovalConfigurationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovalSkipConfiguration
 */
export const GET_APPROVAL_SKIP_CONFIGURATION_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovalSkipConfiguration';
export const GET_APPROVAL_SKIP_CONFIGURATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVAL_SKIP_CONFIGURATION_QUERY_FIELD_NAME,
  args: ['approvalType', 'approvalTypeId', 'approvalAction'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getApprovalSkipConfigurationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalSkipConfiguration
 */
export const PUT_APPROVAL_SKIP_CONFIGURATION_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalSkipConfiguration';
export const PUT_APPROVAL_SKIP_CONFIGURATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUT_APPROVAL_SKIP_CONFIGURATION_MUTATION_FIELD_NAME,
  args: ['approvalType', 'approvalTypeId', 'approvalAction', 'skipApprovalOption', 'usersIdsListThatCanSkipApproval'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.putApprovalSkipConfigurationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#getApprovers
 */
export const GET_APPROVERS_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_getApprovers';
export const GET_APPROVERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVERS_QUERY_FIELD_NAME,
  args: ['approvalType', 'approvalTypeId', 'approvalAction'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getApproversRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#putApprovalConfiguration
 */
export const PUT_APPROVAL_CONFIGURATION_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_putApprovalConfiguration';
export const PUT_APPROVAL_CONFIGURATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUT_APPROVAL_CONFIGURATION_MUTATION_FIELD_NAME,
  args: ['enabled', 'approvalType', 'approvalTypeId', 'approvalAction'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.putApprovalConfigurationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc#sendRequestToEnableApprovals
 */
export const SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsConfigurationRpc_sendRequestToEnableApprovals';
export const SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION_FIELD_NAME,
  args: ['adminToNotifyUserId', 'message', 'approvalType', 'approvalTypeId', 'approvalAction'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.sendRequestToEnableApprovalsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});